import React from 'react';

import { SVGComponentProps } from './svg.types';

const TaskHistoryFieldtaskSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" fill="#EEF1FC" />
        <path d="M9 14H17.5556V15H9V14Z" fill={fill} />
        <path d="M18.3332 14H22.9999V15H18.3332V14Z" fill={fill} />
        <path d="M14.4443 16.0001H22.9999V17.0001H14.4443V16.0001Z" fill={fill} />
        <path d="M9 16.0001H13.6667V17.0001H9V16.0001Z" fill={fill} />
        <path d="M9 18H23V19H9V18Z" fill={fill} />
      </svg>
    </span>
  );
};

export default TaskHistoryFieldtaskSVG;
